import axios from "axios";
import instance from "../../../../axios";

export const BASE_URL = `${process.env.REACT_APP_API_URL}`;
export const LOCAL_URL = `${process.env.REACT_APP_API_URL_LOCAL}`;



export function fetchCompanyList(queryParams) {
    return instance.post(`${BASE_URL}/company/list-new`, queryParams)
        .then(res => {
            return res;
        })
};


export function fetchCompanyDropdownList(queryParams) {
    return instance.post(`${BASE_URL}/company/Dropdown/list`, queryParams)
        .then(res => {
            return res;
        })
};

export function getCompanyById(id) {
    //return axios.post(`${LOCAL_URL}/appsflyer-tokens/get/${id}`);
    return instance.get(`${BASE_URL}/company/get/${id}`)
        .then(res => {
            return res;
        })
}

